/**
 * Hook misji „Przymierz 2 czapki" — tylko EMIT (W9-B / QuestLayer).
 * Payload niesie id itemu; ta sama czapka dwa razy nie liczy się dwa razy.
 */
export const INTERACT_BUS_EVENT = 'pieskowo:interact';
export const WARDROBE_QUEST_ID = 'wardrobe_try_hats' as const;

export type WardrobeMissionPayload = {
  sceneKey: 'Wardrobe';
  questId: typeof WARDROBE_QUEST_ID;
  stepKind: 'try_hat';
  itemId: string;
};

export type WardrobeHatProgress = {
  /** Unikalne id czapek już policzone. */
  triedHatIds: string[];
};

export function createWardrobeHatProgress(): WardrobeHatProgress {
  return { triedHatIds: [] };
}

export function isHatSlot(slot: string | undefined | null): boolean {
  return slot === 'hat';
}

/**
 * Rejestruje przymierzenie czapki. Inny slot / ta sama czapka → advanced=false.
 */
export function recordWardrobeHat(
  progress: WardrobeHatProgress,
  itemId: string,
  slot: string | undefined | null,
): {
  progress: WardrobeHatProgress;
  advanced: boolean;
  payload: WardrobeMissionPayload | null;
} {
  if (!itemId || !isHatSlot(slot) || progress.triedHatIds.includes(itemId)) {
    return { progress, advanced: false, payload: null };
  }
  const triedHatIds = [...progress.triedHatIds, itemId];
  return {
    progress: { triedHatIds },
    advanced: true,
    payload: {
      sceneKey: 'Wardrobe',
      questId: WARDROBE_QUEST_ID,
      stepKind: 'try_hat',
      itemId,
    },
  };
}

/** Mapper bez stanu — tylko slot hat + itemId. */
export function wardrobeMissionFromHat(itemId: string, slot: string | undefined | null): WardrobeMissionPayload | null {
  if (!itemId || !isHatSlot(slot)) return null;
  return {
    sceneKey: 'Wardrobe',
    questId: WARDROBE_QUEST_ID,
    stepKind: 'try_hat',
    itemId,
  };
}
